import { Component, VERSION } from '@angular/core';
import {
  breadcrumb,
  link,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { ImageUploadQuestion } from 'src/app/misc/component/dynamic-form/question-imageupload';
import { DataService } from 'src/app/services/data.service';
import icons from '../../../../misc/data/icons.json';
import { SelectItem } from 'primeng/api/selectitem';
import { TreeSelectQuestion } from 'src/app/misc/component/dynamic-form/question-treeselect';
import { TreeNode } from 'primeng/api/treenode';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DisabledQuestion } from 'src/app/misc/component/dynamic-form/question-disabled';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { RadioButtonQuestion } from 'src/app/misc/component/dynamic-form/question-radiobutton';

import { GlobalConstants } from 'src/app/services/global-constants';
import { data_fields, data_item, data_type } from 'src/app/misc/interface/data';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import * as XLSX from 'xlsx';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { IconBoxQuestion } from 'src/app/misc/component/dynamic-form/question-iconbox';
import { ExportService } from 'src/app/services/export.service';

@Component({
  selector: 'app-bulk',
  templateUrl: './bulk.component.html',
  styleUrls: ['./bulk.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class BulkComponent {

bulkerror:any;
hideBulkOuButton = false;
  ouFunctionObject: { uploadArray: any[]; submitArrayOfItems: any[]; missing_entities: any[]; } = {
    uploadArray: [],
    submitArrayOfItems: [],
    missing_entities: []
  }

  
  translator:TranslatorPipe = new TranslatorPipe()
  currentmissingname: any;
  tempdialog: any = false;
  dataTypes: any;

updateSharedData($event: data_item[]) {
  this.data = $event;
}
deleteItem(data: any) {
  throw new Error('Method not implemented.');
}
  

async selectItem(data: any) {
  this.data = data;
  await this.setMissingEntities(data);
}



  messages: Message[] = [];

  header = this.translate('Load data file');
  links: link[] = [
    // {
    //   name: 'Back',
    //   icon: 'pi pi-arrow-left',
    //   link: '/admin/data',
    //   visible: this.permissionService.hasPermission('BULK_UPLOAD', 'r'),
    // },
    // {
    //   name: 'Add Data',
    //   icon: 'pi pi-plus',
    //   link: '/admin/data/add',
    //   visible: this.permissionService.hasPermission('BULK_UPLOAD', 'c'),
    // },
    // {
    //   name: 'Types',
    //   icon: 'pi pi-list',
    //   link: '/admin/data/types',
    //   visible: this.permissionService.hasPermission('DATA_TYPE', 'r'),
    // },
  ];

  skelition: boolean = true;

  breadcrumbs: breadcrumb[] = [{ name: this.translate('Load data file'), link: '/home' }];
  stats: stat[] = [];

  data: any[] = [];
  entities: any = [];

  missing_entities: any[] = [];
  visible: boolean = false;
  maxId: number = 0;
  iconOptions: SelectItem[] = [];
  treedata: TreeNode[] = [];

  questions: QuestionBase<string>[] = [];

  fields_names: any[] = [];

  missing_fields: any[] = [];

  missingFieldVisible = false;

  missingTypeVisible = false;

  SaveDraftVisible = false;

  missingtypefix: any;

  updateQuestions: any;

  fieldType: any[] = [];

  draftName: string = '';
  draftSaved: boolean = false;
  data_draft: any;

  data_item_to_data_conv( data_item: data_item[]){
    

    var temp_items: any = []
    

    data_item.forEach((item: data_item) => {

      var entity = item?.breadcrumbs && (typeof item?.breadcrumbs[0].label !== 'undefined') ? item?.breadcrumbs[0].label : null;

      var tempfields: any = []
      item.fields?.forEach((field: data_fields) => {
        if(field.label)
          tempfields[field.label.name] = field.data;
      })

      temp_items.push({
        "العنوان": item.name,
        "الوزارات / كيانات أخرى": item?.breadcrumbs && (typeof item?.breadcrumbs[0].label !== 'undefined') ? item?.breadcrumbs[0].label : null,
        "النوع":  item.type?.arabic,
        "العنوان الرئيسي": item?.breadcrumbs && (typeof item?.breadcrumbs[1].label !== 'undefined') ? item?.breadcrumbs[1].label : entity,
        "العنوان الفرعي": item?.breadcrumbs && (typeof item?.breadcrumbs[2].label !== 'undefined') ? item?.breadcrumbs[2].label : entity,
        ...tempfields
      })


    });

    return temp_items;
  }

  async saveDraft() {
    
    var item = {
      user: {
        _id: localStorage.getItem("uid"),
        user: localStorage.getItem("username"),
      },
      object: {
        name: this.draftName,
        data: this.data_item_to_data_conv(this.data_items)
      }
    }

    console.log("output",item);

    let res = await this.dataService.postData('draft', item);
    if (res.error) {
      console.log(res.error);
      return;
    }

    // For demonstration purposes, we'll set draftSaved to true after a brief delay
    setTimeout(() => {
      this.draftSaved = true;
      // Close the dialog after showing the success message (adjust timing as needed)
      setTimeout(() => {
        this.SaveDraftVisible = false;
        this.draftSaved = false;
        this.draftName = '';
      }, 2000); // Close the dialog after 2 seconds (adjust timing as needed)
    }, 1000); // Simulate saving for 1 second (adjust timing as needed)
  }

  GlobalConstants = GlobalConstants;

  newOu: OrganizationUnit = {
    id: 0,
    name: '',
    image: '',
    image_sq: '',
  };

  apilink = GlobalConstants.apiURL;

  ImageRadio: any = false;
  categories: any = [];
  locations: any = [];
  changeOptions: any = [];
  beforchange: any = '';
  afterchange: string = '';
  changedialog: any = false;
  beforeparent: any = '';
  AddAllvisible: any = false;
  loadingprogress: number = 0;
  loadingprogressTotal: number = 100;

  data_items: data_item[] = [];
  missingField_updateQuestions: QuestionBase<string>[] = [];
  server_field_names: any;
  data_types: any[] = [];
  missing_types: any[] = [];
  server_data_types: any[] = [];
  missingtype: string = '';

  UploadAllDataVisible = false;
  UploadAllDataVisibleClose: boolean = false;
  org_types: any = [];

  constructor(private dataService: DataService,public permissionService:PermissionHandlerService, private exportService: ExportService) {}

  async ngOnInit() {
    this.getIcons();
    this.dataTypes = await this.getDataTypes();
    this.entities = await this.getEntities();
    this.categories = await this.getCategories();
    this.org_types = await this.getOrgTypes();
    this.locations = await this.getLocation();

    this.fetchDataType().then(async () => {
      await this.makeQuestionsForFields();
      await this.fetchDraft().then(() => {
        this.skelition = false;
      });
    });
  }

  async getDataTypes() {
    const typesResponse = await this.dataService.postData('data-type/get', {});
    const response =  await this.dataService.getData('/data-fields/type/with-type');

    const groupedData: { [key: string]: any[] } = {};

    response.data.forEach((item: any) => {
      item["data-type"].forEach((type:any) => {
        if (!groupedData[type]) {
          groupedData[type] = [];
        }
        groupedData[type].push(item);
      });
    });

    const result = typesResponse.data
    .filter((category: any) => category.active === true)
    .map((category: any) => {
      return {
        ...category,
        items: groupedData[category._id] || []
      };
    });
  return result;
    
  }

  downloadTemplate(_t20: any) {
    console.log(_t20);

    let  cleanData : any =  _t20
    let items : any = cleanData.items.reduce((acc: { [x: string]: null; }, item: { name: string | number; }) => {
      acc[item.name] = null;
      return acc;
  }, {});
    const updatedDataArray: any = [{
      "العنوان" : null,
      "الوزارات / كيانات أخرى": null,
      "النوع": null,
      "العنوان الرئيسي": null,
      "العنوان الفرعي": null,
      ...items
    }]
    
    this.exportService.exportContentUpdateExcel(updatedDataArray, cleanData.name + '_template');
  }

  AddAllDialogShow() {
    this.AddAllvisible = true;

    this.loadingprogress = 0;
    this.loadingprogressTotal = this.missing_entities.length;

    // console.log("showing ", this.maxId);
  }

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  async generateData() {
    this.data_items = [];

    // console.log(this.data);

    var fields_names = new Set();

    this.fields_names = [];

    let response = await this.dataService.postData('data-fields/get', {});

    // console.log("datafields", response.data.data)

    this.server_field_names = response.data;

    var datatypes = new Set();

    let response2 = await this.dataService.postData('data-type/get', {});

    this.server_data_types = response2.data;

    // console.log("data_types", response2.data.data)

    this.server_field_names = response.data;

    this.data.forEach((item: any) => {
      Object.keys(item).forEach((keyname) => {
        const remove = [
          'link',
          '_id',
          'العنوان',
          'العنوان الرئيسي',
          'العنوان الفرعي',
          'النوع',
          'الوزارات / كيانات أخرى',
          'نوع الخدمة',
        ];
        if (remove.indexOf(keyname) == -1) {
          fields_names.add(keyname);
        }
      });

      if (typeof item['النوع'] == 'string') {
        datatypes.add(item['النوع'].trim());
      } else {
        // console.log("this is not a string", item['النوع'])
      }
    });

    this.fields_names = Array.from(fields_names);

    // console.log("these fields", this.fields_names);

    this.missing_fields = [];

    this.fields_names.forEach((item) => {
      var index = this.server_field_names.findIndex(
        (x: any) => x.name == item || x?.arabic == item
      );
      if (index == -1) {
        this.missing_fields.push(item);
      }
    });

    //search for missing types in data types
    this.data_types = Array.from(datatypes);

    this.missing_types = [];

    this.data_types.forEach((item) => {
      var index = this.server_data_types.findIndex(
        (x: any) => x.name == item || x?.arabic == item
      );
      if (index == -1) {
        this.missing_types.push(item);
      }
    });

    // console.log(this.missing_types)

    if (this.missing_fields.length == 0 && this.missing_types.length == 0) {
      this.data.forEach((item: any) => {
        let index1 = this.entities.findIndex(
          (x: any) =>
            x.name === item['الوزارات / كيانات أخرى'] && x.parent == null
        );
        let index2 = this.entities.findIndex(
          (x: any) =>
            x.name === item['العنوان الرئيسي'] &&
            x.parent?.name == item['الوزارات / كيانات أخرى']
        );
        let index3 = this.entities.findIndex(
          (x: any) =>
            x.name === item['العنوان الفرعي'] &&
            x.parent?.name == item['العنوان الرئيسي']
        );

        var breadcrumbs = [
          {
            label: this.entities[index1].name,
            icon: this.entities[index1].image_sq,
            id: this.entities[index1].id,
            _id: this.entities[index1]._id,
          },
          {
            label: this.entities[index2].name,
            icon: this.entities[index2].image_sq,
            id: this.entities[index2].id,
            _id: this.entities[index2]._id,
          },
          {
            label: this.entities[index3].name,
            icon: this.entities[index3].image_sq,
            id: this.entities[index3].id,
            _id: this.entities[index3]._id,
          },
        ];

        var cloneitem = { ...item };

        var cloneitem_keys = Object.keys(cloneitem);

        var data_fields: data_fields[] = [];

        cloneitem_keys.forEach((keyname) => {
          const remove = [
            'link',
            '_id',
            'العنوان',
            'العنوان الرئيسي',
            'العنوان الفرعي',
            'النوع',
            'الوزارات / كيانات أخرى',
            'نوع الخدمة',
          ];
          if (remove.indexOf(keyname) == -1) {
            var label = this.server_field_names.filter(
              (x: any) => x.name == keyname || x.arabic == keyname
            );

            data_fields.push({
              label: label[0],
              type: {
                name: 'text',
              },
              data: cloneitem[keyname],
            });
          }
        });

        if (typeof item['النوع'] == 'string') {
          this.server_data_types.forEach((val) => {
            if (val.name == item['النوع'] || val.arabic == item['النوع']) {
              item['النوع'] = val;
            }
          });
        }

        if (typeof item['النوع'] == 'object') {
          this.data_items.push({
            id: item._id,
            name: item['العنوان'],
            type: item['النوع'],
            breadcrumbs: breadcrumbs,
            fields: data_fields,
          });
        }
      });
    }
  }

  async generateUploadArray() {

    var missing_entities: any[] = [];

    let submitArrayOfItems: any[] = [];

    let uploadArray: any[] = [];

    let i = 0;

    this.missing_entities.forEach(
      
      async (item: any) => {

        if(item.parent != null){
          await this.dataService.postData('ou/getParentID', {
            name: item.parent,
            parent: item.grandparent
          }).then(async (parent: any) => {

            console.log("parent", parent)

            if(parent?.data.length > 0) {

              let parentId = parent?.data[0]._id

              i = i + 1;

              uploadArray.push({
                id: this.maxId + i,
                name: item.name,
                parent: parentId,
                category: this.newOu.category?._id,
                location: this.newOu.location?._id,
                active: true,
                type: this.newOu.type?._id,
                image:
                  this.ImageRadio == true ? this.newOu.image : this.newOu.image_sq,
                image_sq:
                  this.ImageRadio == true ? this.newOu.image : this.newOu.image_sq,
              });

              console.log("now items ==================>", uploadArray)
              submitArrayOfItems.push(item);

            } else {
              missing_entities.push(item);
            }

          });


        } else {
          i = i + 1;

          uploadArray.push({
            id: this.maxId + i,
            name: item.name,
            parent: null,
            category: this.newOu.category?._id,
            location: this.newOu.location?._id,
            active: true,
            type: this.newOu.type?._id,
            image:
              this.ImageRadio == true ? this.newOu.image : this.newOu.image_sq,
            image_sq:
              this.ImageRadio == true ? this.newOu.image : this.newOu.image_sq,
          });

          submitArrayOfItems.push(item);
        }
      }
    )

    return {
      uploadArray: uploadArray,
      submitArrayOfItems: submitArrayOfItems,
      missing_entities: missing_entities
    }
  }

  async AddAllDialogSubmit() {

    this.hideBulkOuButton=true;

    this.loadingprogress = 0;
    this.loadingprogressTotal = this.missing_entities.length;

    var missing_entities: any[] = []

    // Use Promise.all() to await all the promises and collect the results
  Promise.all(this.missing_entities.map(async (item: any, index) => {
    if (item.parent != null) {
      const res = await this.dataService.postData('ou/getParentID', { name: item.parent, parent: item.grandparent });
      if (!res.error) {
        if (res.data.length > 0) {
          return {
            id: this.maxId + index + 1,
            name: item.name,
            parent: res.data[0]._id,
            category: this.newOu.category?._id,
            location: this.newOu.location?._id,
            active: true,
            type: this.newOu.type?._id,
            image: this.ImageRadio == true ? this.newOu.image : this.newOu.image_sq,
            image_sq: this.ImageRadio == true ? this.newOu.image : this.newOu.image_sq,
          };
        } 
      } 
    } else {
        return {
          id: this.maxId + index + 1,
          name: item.name,
          parent: null,
          category: this.newOu.category?._id,
          location: this.newOu.location?._id,
          active: true,
          type: this.newOu.type?._id,
          image: this.ImageRadio == true ? this.newOu.image : this.newOu.image_sq,
          image_sq: this.ImageRadio == true ? this.newOu.image : this.newOu.image_sq,
        };
    }
    missing_entities.push(item);
    return null;
  }))
  .then(async (uploadArray) => {
    const filteredUploadArray = uploadArray.filter((item) => item !== null);
    console.log("UPLOAD ARRAY!!! =============>", filteredUploadArray);

    const res = await this.dataService.postData('ou/bulk', {
      data: filteredUploadArray
    })

    if(!res.error) {

      this.loadingprogress += filteredUploadArray.length;

      this.missing_entities = missing_entities;

      Promise.all([
        this.entities = await this.getEntities()
      ]).then(async () => {
        await this.setMissingEntities(this.data);
      });

      this.bulkerror = "نجاح! لقد قمت بتحميل  " + filteredUploadArray.length + " عناصر."

      this.hideBulkOuButton= false;
      
    } else {
      this.bulkerror = "ERROR!"
    }
  })
  .catch((error) => {
    this.bulkerror = "ERROR! " + error
    console.error("Error:", error);
  });


  }

  async AddAllDialogSubmit2() {

    try {
      this.hideBulkOuButton=true;

      this.loadingprogress = 0;
      this.loadingprogressTotal = this.missing_entities.length;

      this.ouFunctionObject = {
        uploadArray: [],
        submitArrayOfItems: [],
        missing_entities: []
      }
      
      this.ouFunctionObject = await this.generateUploadArray();

      
          console.log("Submissing array size", this.ouFunctionObject.uploadArray.length);


          const res = await this.dataService.postData('ou/bulk', {
            data: this.ouFunctionObject.uploadArray
          })
    
          if(!res.error) {
    
            this.loadingprogress += this.ouFunctionObject.submitArrayOfItems.length;
    
            this.missing_entities = this.ouFunctionObject.missing_entities;
    
            Promise.all([
              this.entities = await this.getEntities()
            ]).then(async () => {
              await this.setMissingEntities(this.data);
            });
    
            this.bulkerror =  "نجاح! لقد قمت بتحميل  " +  this.ouFunctionObject.submitArrayOfItems.length  + " عناصر."
    
            this.hideBulkOuButton= false;
            
          } else {
            this.bulkerror = "ERROR!"
          }

      // Proceed with your code that depends on uploadArray
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  
  }

  async newOuSubmit() {
    // console.log(this.newOu);
    let submit: any = {
      id: this.newOu.id,
      name: this.newOu.name,
      parent: this.newOu.parent?._id,
      category: this.newOu.category?._id,
      type: this.newOu.type?._id,
      location: this.newOu.location?._id,
      active: true,
    };

    if (this.ImageRadio == true) {
      submit.image = this.newOu.image;
      submit.image_sq = this.newOu.image;
    } else {
      submit.image = this.newOu.image_sq;
      submit.image_sq = this.newOu.image_sq;
    }

    let response = await this.dataService.postData('ou', submit);

    let index1 = this.missing_entities.findIndex(
      (x: any) =>
        x.name === this.newOu.name && x.parent == this.newOu.parent?.name
    );

    if (index1 != -1) {
      this.missing_entities.splice(index1, 1);
    } else {
      // console.log("why", this.newOu.name, this.newOu.parent?.name)
    }

    if (!response.error) {
      // console.log(response);
      this.ngOnInit();
      this.visible = false;
    } else {
      // console.log(response.error)
    }
  }

  onUpload(event: any) {
    // console.log(event);
    this.newOu.image = event.originalEvent.body.data;
  }

  name = 'Angular ' + VERSION.major;

  lines: any = [];
  linesR: any = [];

  changeName(arg0: any, arg1: any) {
    this.beforchange = arg0;
    this.beforeparent = arg1;
    this.changeOptions = this.entities.filter(
      (x: any) => x.parent?.name == arg1
    );
    this.afterchange = '';
    this.changedialog = true;
  }

  commitchange(arg0: any, arg1: any, arg2: any) {
    // console.log(arg1)

    this.data.forEach((item: any) => {
      if (arg2 == null && item['الوزارات / كيانات أخرى'] === arg0) {
        item['الوزارات / كيانات أخرى'] = arg1.name;
      } else if (
        arg2 != null &&
        arg2 == item['الوزارات / كيانات أخرى'] &&
        item['العنوان الرئيسي'] == arg0
      ) {
        item['العنوان الرئيسي'] = arg1.name;
      } else if (
        arg2 != null &&
        arg2 == item['العنوان الرئيسي'] &&
        item['العنوان الفرعي'] == arg0
      ) {
        item['العنوان الفرعي'] = arg1.name;
      }
    });

    this.setMissingEntities(this.data);

    this.changedialog = false;
  }

  async showDialog(item: string, parent: string, grandparent: string) {
    // console.log(this.maxId);

    this.newOu.id = this.maxId + 1;
    this.newOu.name = item;
    this.newOu.image_sq = 'file';

    let index1 = this.entities.findIndex(
      (x: any) => x.name === parent && x.parent?.name == grandparent
    );

    if (index1 != -1) this.newOu.parent = this.entities[index1];
    //this.entities.findIndex()
    //this.newOu.parent =
    this.visible = true;
  }

  changeListener(files: any) {
    let fileList = (<HTMLInputElement>files.target).files;
    if (fileList && fileList.length > 0) {
      let file: File = fileList[0];
      // console.log(file.name);
      // console.log(file.size);
      console.log(file.type);

      if (file.type == 'text/csv') {
        let reader: FileReader = new FileReader();
        reader.readAsText(file);
        reader.onload = async (e) => {
          let csv: any = reader.result;
          // console.log("csv",csv)
          let allTextLines = [];
          allTextLines = csv.split(/\r\n/);

          let headers = allTextLines[0].split(',');

          let obj: any[] = [{}];

          for (let i = 0; i < allTextLines.length; i++) {
            for (let j = 0; j < headers.length; j++) {
              if (typeof headers[j] == 'string')
                if (obj[i]) {
                  obj[i][headers[j]] = allTextLines[i].split(',')[j];
                } else {
                  obj[i] = {};
                  obj[i][headers[j]] = allTextLines[i].split(',')[j];
                }
            }
          }

          obj.shift();

          this.data = obj;

          await this.setMissingEntities(obj);
        };
      } else {
        const target: DataTransfer = <DataTransfer>(<unknown>files.target);
        if (target.files.length !== 1) {
          throw new Error('Cannot use multiple files');
        }
        const reader: FileReader = new FileReader();
        reader.readAsBinaryString(target.files[0]);
        reader.onload = async (e: any) => {
          /* create workbook */
          const binarystr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

          /* selected the first sheet */
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];

          /* save data */
          const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
          console.log(data); // Data will be logged in array format containing objects

          this.data = data;

          await this.setMissingEntities(data);
        };
      }
    }
  }

  async setMissingEntities(data: any) {
    let missing_a: any[] = [];
    let missing_b: any[] = [];
    let missing_c: any[] = [];


    await data.forEach((item: any) => {
      let index1 = this.entities?.findIndex(
        (x: any) =>
          x.name === item['الوزارات / كيانات أخرى'] && x.parent == null
      );
      if (index1 == -1) {
        let index1x = -1;
        for (let i = 0; i < missing_a.length; i++) {
          if (
            missing_a[i].name === item['الوزارات / كيانات أخرى'] &&
            missing_a[i].parent == null
          ) {
            index1x = i;
          }
        }

        if (index1x == -1) {
          missing_a.push({
            name: item['الوزارات / كيانات أخرى'],
            parent: null,
            grandparent: null,
          });
        }
      }

      let index2 = this.entities?.findIndex(
        (x: any) =>
          x.name === item['العنوان الرئيسي'] &&
          x.parent?.name == item['الوزارات / كيانات أخرى']
      );
      if (index2 == -1) {
        let index2x = -1;
        for (let i = 0; i < missing_b.length; i++) {
          if (
            missing_b[i].name === item['العنوان الرئيسي'] &&
            missing_b[i].parent === item['الوزارات / كيانات أخرى']
          ) {
            index2x = i;
          }
        }
        if (index2x == -1) {
          missing_b.push({
            name: item['العنوان الرئيسي'],
            parent: item['الوزارات / كيانات أخرى'],
            grandparent: null,
          });
        }
      }

      let index3 = this.entities?.findIndex(
        (x: any) =>
          x.name === item['العنوان الفرعي'] &&
          x.parent?.name == item['العنوان الرئيسي']
      );
      if (index3 == -1) {
        let index3x = -1;
        for (let i = 0; i < missing_c.length; i++) {
          if (
            missing_c[i].name === item['العنوان الفرعي'] &&
            missing_c[i].parent === item['العنوان الرئيسي']
          ) {
            index3x = i;
          }
        }
        if (index3x == -1) {
          missing_c.push({
            name: item['العنوان الفرعي'],
            parent: item['العنوان الرئيسي'],
            grandparent: item['الوزارات / كيانات أخرى'],
          });
        }
      }
    });

    

    let missing = [...missing_a, ...missing_b, ...missing_c];

    this.missing_entities = missing;

    console.log("Missing entitiels=>",this.missing_entities)


  }

  async getEntities() {
    try {
      let response = await this.dataService.getData('ou/');

      // console.log(response);

      let data = response.data;

      // console.log("max =>",Math.max(...data.map((o:any) => { if(typeof o.id == "number" ) return o.id }) ));

      this.maxId = Math.max(...data.map((o: any) => o.id)) + 1;

      return response.data;
    } catch (error) {
      // console.log(error)
    }
  }

  async getLocation() {
    try {
      let response = await this.dataService.getData('location/');
      // console.log(response);
      let data = response.data;
      return data;
    } catch (error) {
      // console.log(error)
    }
  }

  async getCategories() {
    try {
      let response = await this.dataService.getData('ou-category/');
      // console.log(response);
      let data = response.data;
      return data;
    } catch (error) {
      // console.log(error)
    }
  }

  async getOrgTypes() {
    try {
      let response = await this.dataService.getData('ou-type/');
      // console.log(response);
      let data = response.data;
      return data;
    } catch (error) {
      // console.log(error)
    }
  }

  makequestion(name: string, parent: string) {
    this.questions = [
      new ImageUploadQuestion({
        key: 'image_sq',
        label: 'Square Logo Upload',
        order: 8,
        icon: 'pi pi-file',
        help: 'Please upload square image with logo only.',
        visibility: 'this.form.get("icontype").value == true',
      }),

      new ImageUploadQuestion({
        key: 'image',
        label: 'Logo Upload',
        order: 9,
        icon: 'pi pi-file',
        help: 'Please upload image.',
        visibility: 'this.form.get("icontype").value == true',
      }),

      new IconBoxQuestion({
        key: 'icon',
        label: 'Icon',
        
        filter: true,
        order: 7,
        visibility: 'this.form.get("icontype").value == false',
      }),

      new RadioButtonQuestion({
        key: 'icontype',
        label: 'Icon Type',
        options: [
          { label: 'Image', icon: 'pi pi-image', value: 'image' },
          { label: 'Icon', icon: 'pi pi-flag', value: 'icon' },
        ],
        order: 6,
      }),

      new DropdownQuestion({
        key: 'location',
        label: this.translate('Location'),
        options: [
          { label: this.translate('Riyadh'), value: 'الرياض' },
          { label: this.translate('grandmother'), value: 'جدة' },
          { label: this.translate('Mecca'), value: 'مكة' },
          { label: this.translate('City'), value: 'المدينة' },
          { label: this.translate('Al Mubarraz'), value: 'الهفوف و المبرز' },
          { label: this.translate('Taif'), value: 'الطائف' },
          { label: this.translate('Tabuk'), value: 'تبوك' },
        ],
        order: 5,
        filter: true,
      }),

      new DropdownQuestion({
        key: 'category',
        label: 'Category',
        options: [{ label: 'none', icon: 'pi pi-times-circle', value: 'none' }],
        order: 4,
      }),

      new DropdownQuestion({
        key: 'type',
        label: 'Type',
        options: [
          { label: this.translate('Ministries'), icon: 'pi pi-briefcase', value: 'ministry' },
          { label: this.translate('other entities'), icon: 'pi pi-building', value: 'entity' },
          { label: this.translate('organizational unit'), icon: 'pi pi-sitemap', value: 'ou' },
        ],
        order: 3,
      }),

      new TreeSelectQuestion({
        key: 'parent',
        label: this.translate('Parent OU'),
        treeOptions: this.treedata,
        order: 2,
        icon: 'pi pi-file',
        filter: true,
        value: parent,
      }),

      new TextboxQuestion({
        key: 'name',
        label: this.translate('Organizational unit name'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        value: name,
      }),

      new DisabledQuestion({
        key: 'id',
        label: this.translate('ID'),
        type: 'text',
        order: 0,
        icon: 'pi pi-list',
        value: (this.maxId + 1).toString(),
      }),
    ];
  }

  getIcons() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });
  }

  getTreeData() {
    var _ministries: TreeNode[] = [];
    var _entities: TreeNode[] = [];
    var _ous: TreeNode[] = [];

    var level1 = this.entities.filter((entity: OrganizationUnit) => {
      return !entity.parent;
    });

    level1.forEach((item: OrganizationUnit) => {
      if (item.type) {
        if (item.type?.name == 'ministry') {
          _ministries.push({
            label: item.name,
            data: item.image_sq,
            children: this.findAll(item.name),
          });
        } else if (item.type?.name == 'entity') {
          _entities.push({ label: item.name, data: item.image_sq });
        } else {
          _ous.push({ label: item.name, data: item.image_sq });
        }
      } else {
        _ous.push({ label: item.name, data: item.image_sq });
      }
    });

    this.treedata = [
      {
        label: this.translate('Participating entities'),
        expanded: false,
        data: '19eac9488f9377b374788d8ea91d7be7.png',
        children: [
          {
            label: this.translate('Ministries'),
            data: 'pi pi-briefcase',
            expanded: false,
            children: _ministries,
          },
          {
            label: this.translate('other entities'),
            data: 'pi pi-building',
            expanded: false,
            children: _entities,
          },
          {
            label: this.translate('organizational unit'),
            data: 'pi pi-sitemap',
            expanded: false,
            children: _ous,
          },
        ],
      },
    ];
  }

  findAll(name: string) {
    var children: TreeNode[] = [];

    var temp = this.entities.filter((item: OrganizationUnit) => {
      return item.parent?.name == name;
    });

    if (temp.length > 0) {
      temp.forEach((item: OrganizationUnit) => {
        children.push({
          label: item.name,
          data: item.image_sq,
          children: this.findAll(item.name),
        });
      });
    }

    return children;
  }

  makeQuestionsForFields() {
    this.missingField_updateQuestions = [
      new DisabledQuestion({
        key: 'name',
        label: this.translate('Organizational unit class name'),
        required: false,
        value: this.currentmissingname,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'type',
        label:this.translate('type'),
        required: true,
        options: this.fieldType,
        filter: true,
        order: 2,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new IconBoxQuestion({
        key: 'icon',
        label: this.translate('Icon'),
        required: true,
        
        filter: true,
        order: 3,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: this.translate('Active'),
        options: [
          { label: 'نعم', icon: 'pi pi-check-circle', value: true },
          { label: 'لا', icon: 'pi pi-times-circle', value: false },
        ],
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: 'false',
      }),
    ];
  }

  async MissingFields(_t158: any) {
    // console.log("questions", this.missingField_updateQuestions)

    this.currentmissingname = _t158;

    console.log("current missing name",this.currentmissingname);

    if (this.missingField_updateQuestions[0]) {
      this.missingField_updateQuestions[0].value = _t158;
    }

    this.missingFieldVisible = true;
  }

  private async fetchDataType(): Promise<void> {
    let res = await this.dataService.postData('field-type/get', {
      active: true,
    });
    // console.log(res.data);
    if (res.error) {
      return;
    }
    this.fieldType = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        icon: `pi pi-${item.icon}`,
        value: item._id,
      };
    });
  }

  private async fetchDraft(): Promise<void> {
    let res = await this.dataService.postData('draft/get', {});
    // console.log(res.data);
    if (res.error) {
      return;
    }
    this.data_draft = res.data;
  }

  async missingField_create($event: any) {
    try {
      let data = {
        name: this.currentmissingname,
        type: $event.type,
        icon: $event.icon,
        active: $event.active
      };


      console.log(data.name, "this has started", this.currentmissingname)

      let res = await this.dataService.postData('data-fields/', data);
      if (res.error) {
        // console.log(res.error);

        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      } else {
        this.messages = [
          { severity: 'success', summary: this.translate('success'), detail: res.msg },
        ];

        await this.generateData().then(() => {
          this.missingFieldVisible = false;
        });
        // console.log(res);
      }
    } catch (error) {
      // console.log(error);
    }
  }

  MissingTypes(type: string) {
    this.missingTypeVisible = true;
    this.missingtype = type;
  }

  async missingTypeChange(arg0: string, arg1: any) {
    this.data.forEach((item: any) => {
      if (item['النوع'] == arg0) {
        item['النوع'] = arg1;
      }
    });

    await this.generateData().then(() => {
      this.missingTypeVisible = false;
    });
  }

  async UploadAllData(arg0: data_item[]) {
    var response = await this.dataService.getData('data/sequence');

    var sequence = response.data + 1;

    var uploadArray: any[] = [];

    console.log(response.data);

    console.log('upload is starting');

    await arg0.forEach(async (data: data_item, index: number) => {
      var datafields: any[] = [];
      await data.fields?.forEach((field: any, i: number) => {
        datafields.push({
          label: field.label?.name,
          type: field.label?._id,
          data: field.data,
        });

        if (field.item_Id) {
          datafields[i].item_Id = field.item_Id;
          datafields[i].item_Field = field.item_Field;
        }
      });

      if (data.type && data.breadcrumbs) {
        var uploadObject = {
          id: sequence + index,
          name: data.name,
          type: data.type._id,
          fields: datafields,
          ous: data.breadcrumbs[data.breadcrumbs.length - 1]?._id,
        };

        uploadArray.push(uploadObject);

        if (index < 2) {
          console.log('example upload', uploadObject);
        }
      } else {
        console.log(
          'example that didnt upload',
          data.id,
          data.type,
          data.breadcrumbs
        );
      }
    });

    
    console.log('uploadArray', uploadArray);
    try {
      response = await this.dataService.postData('data/bulkupload', {
        data: uploadArray,
      });
      
      if (!response.error) {
        var Uploaded = response.data;

        console.log("UPLOADED ======>>>>", Uploaded);

        var notUploaded = uploadArray.filter(object1 => {
          return !Uploaded.some((object2: { id: number; }) => {
            return object1.id === object2.id;
          });
        });
        
        
        console.log("not", notUploaded);

        this.data_items = notUploaded;

        if(notUploaded.length < 1 ) {
          const res = await this.dataService.getData('ou/clean');
          if(!res.error) {
            this.UploadAllDataVisible = false
            window.location.reload();
            this.ngOnInit();
          }
        }
        
      }
    } catch (error) {
      console.log(error);
    }
  }


}
